// submits/state.js

import { delFormInitialState } from "../../forms/delForm/delFormState";

export const activeDelSubmitsInitialState = {
  tabName: "submitted",
  isLoading: false,
  error: null,
  delMode: null,
  currentDel: null,
  delErrors: null,
  delActiveTab: "projects",
  delShowAll: false,
  delForm: delFormInitialState,
};
